import {Injectable} from "@angular/core";
import {DeleteListUseCaseUseCase} from "@app/core/lists/application/delete-list.use-case.use-case";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {Observable, Subscriber} from "rxjs";
import {take} from "rxjs/operators";
import {createStatusStore} from "@app/presentation/rxjs-utils/create-status-store";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";

@Injectable({
    providedIn: 'root'
})
export class DeleteListViewModel {

    public notifier = new PopupNotifier();
    private succeedEmitter!: Subscriber<void>;
    public deleteListSucceed$: Observable<void> = new Observable<void>(emitter => this.succeedEmitter = emitter)
    constructor(
        private deleteListUseCaseUseCase: DeleteListUseCaseUseCase
    ) { }

    private deleteListStatus = createStatusStore();
    readonly isDeleteListLoading$ = this.deleteListStatus.isLoading$;

    deleteList(listId: number): void {
        this.deleteListUseCaseUseCase.execute(listId)
            // ensure that the use case won't be executed more than one time, 
            // since you can't delete the same list more than once.
            .pipe(
                take(1),
                onIsLoadingChanges(this.deleteListStatus.setIsLoading),
            )
            .subscribe({
                next: () => {
                    this.succeedEmitter.next();
                },
                error: error => {
                    this.notifier.notifyError(error);
                }
            });
    }

}